export enum NewMatchDailyFrequency {
    FourTimesPerDay = 3732,
    OncePerDay = 3730,
    TwoTimesPerDay = 3731
}